import NProgress from 'nprogress'
import store from '@/store'
import { http } from '@/plugins/http';

const beforeEach = async (to, from, next) => {
  NProgress.start();
  let pageSetting = await getHomepageLayout();
  if (pageSetting) {
    store.dispatch('setConfigSetting', pageSetting);
  } else {
    alert('获取模板配置信息失败！')
  }
  next()
}

async function getHomepageLayout () {

  let params = {
    tenant_id: store.getters.tenantId,
    is_cache: 1,
  };
  return await http.get(window.CONFIG.HOMEPAGE_LAYOUT_SETTINGS, { params })
    .then((res) => {
      if (res.data.code == 200) {
        return res.data.data;
      } else {
        return null;
      }
    }).catch(error => {
      return null;
    });
}


export default beforeEach



// WEBPACK FOOTER //
// ./src/router/beforeEach.js